<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
                <el-form :model="searchForm" inline size="small">
                    <el-form-item label="分类">
                        <el-input class="width_200"
                                  @change="getTableData"
                                  v-model="searchForm.input"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getTableData" type="primary">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <el-button @click="add_dialog" size="small">新增字典</el-button>
            </div>
        </div>
        <div class="table">
            <el-table :data="tableData"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                              @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                :modal-append-to-body="false"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="450px">
            <div class="dialog_box">
                <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                    <el-form-item label="分类" prop="dict_name">
                        <el-input v-model="form.dict_name" class="width_220"></el-input>
                    </el-form-item>
                    <el-form-item label="value" prop="value">
                        <el-input v-model="form.value" class="width_220"></el-input>
                    </el-form-item>
                    <el-form-item label="name">
                        <el-input v-model="form.name" class="width_220"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="submit_dialog()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "tableView",
        data() {
            return {
                searchForm: {
                    input: '',
                },
                tableData: [],
                columnData: [
                    {label: '分类', prop: 'dict_name'},
                    {label: 'value', prop: 'value'},
                    {label: 'name', prop: 'name'},
                ],

                form: {},
                rules: {
                    dict_name: [{required: true, message: '请输入分类', target: 'blur'}],
                    value: [{required: true, message: '请输入value', target: 'blur'}],
                },
                dialogVisible: false,
                dialogTitle: '新增字典',
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            getTableData() {
                console.log('get_data');
                let params = {
                    dict_name: this.searchForm.input,
                };
                this.httpGet('/cdict/list', params).then(res => {
                    this.tableData = res.data;
                });
            },
            add_dialog() {
                this.form = {
                    dict_name: '',
                    value: '',
                    name: '',
                };
                this.dialogTitle = '新增字典';
                this.dialogVisible = true;
                this.$nextTick(() => this.$refs.form.clearValidate())
            },
            editRow(row) {
                this.form = clone(row);
                this.dialogTitle = '修改字典';
                this.dialogVisible = true;
                this.$nextTick(() => this.$refs.form.clearValidate())
            },
            submit_dialog() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let params = {...this.form};
                        this.httpPost('/cdict/save', params).then(res => {
                            this.$message.success('保存成功');
                            this.dialogVisible = false;
                            this.getTableData();
                            this.getUseDictionary()
                        })
                    }
                })
            },

            delRow(row) {
                this.$confirm('确定要删除该字典么？').then(() => {
                    this.httpDel(`/cdict/${row.item_id}`).then(res => {
                        if (res.code === 0) {
                            this.$message.success('已成功删除！');
                            this.getTableData();
                            this.getUseDictionary()
                        }
                    })
                })
            },

            getUseDictionary() {
                this.$eventBus.$emit('getClassifyList')
            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>